<template>
  <v-form ref="form">
    <v-container grid-list-md class="px-3">
      <v-layout wrap>
        <v-flex xs12 v-if="!enrolmentDone">
          <page-header-title :title="$t('fe.enrolment.enrol') + ': ' + page_title" class="enr-title mt-4 mb-4"></page-header-title>

          <v-container grid-list-md class="pa-0">
            <v-layout wrap>
              <v-flex lg8 md8 sm12 xs12 v-if="!enrolmentDone">
                <v-card>
                  <v-card-text class="pa-4">
                    <v-container grid-list-md class="pa-0">
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-subheader class="pl-0">{{ $t("fe.enrolment.details") }}</v-subheader>

                          <v-layout wrap>
                            <v-flex lg4 md4 sm6 xs12>
                              <v-text-field
                                name="p_first_name"
                                v-model="enrolment.first_name"
                                class="required-field"
                                v-validate="'required|max:50'"
                                :label="$t('fe.enrolment.p_first_name')"
                                :error-messages="errors.collect('p_first_name')"
                                :disabled="fields_disabled"
                                autocomplete="new-password"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 md4 sm6 xs12>
                              <v-text-field
                                name="p_last_name"
                                v-model="enrolment.last_name"
                                class="required-field"
                                v-validate="'required|max:50'"
                                :label="$t('fe.enrolment.p_last_name')"
                                :error-messages="errors.collect('p_last_name')"
                                :disabled="fields_disabled"
                                autocomplete="new-password"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 md4 sm6 xs12>
                              <v-text-field
                                name="p_email"
                                v-model="enrolment.email"
                                class="required-field"
                                v-validate="'required|email|max:255'"
                                :label="$t('fe.enrolment.p_email')"
                                :error-messages="errors.collect('p_email')"
                                :disabled="fields_disabled"
                                autocomplete="new-password"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 md4 sm6 xs12>
                              <vue-tel-input-vuetify
                                v-validate="'required|max:50'"
                                :label="$t('fe.enrolment.p_mobile')"
                                class="required-field"
                                v-model="enrolment.mobile"
                                @input="
                                  (formattedNumber, { number, valid, country }) => {
                                    enrolment.mobile = number.significant || formattedNumber
                                    enrolment.mobile_code = country.dialCode || null
                                  }
                                "
                                placeholder=""
                                name="p_mobile"
                                :error-messages="errors.collect('p_mobile')"
                                defaultCountry="NO"
                                :disabled="fields_disabled"
                              ></vue-tel-input-vuetify>
                            </v-flex>
                            <v-flex lg4 md4 sm6 xs12>
                              <v-dialog ref="dialog" v-model="dob_date_menu" persistent width="290px">
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    name="p_date_of_birth"
                                    v-model="computedDateofBirth"
                                    :label="$t('fe.enrolment.p_date_of_birth')"
                                    class="required-field"
                                    v-validate="'required|validDate'"
                                    :error-messages="errors.collect('p_date_of_birth')"
                                    append-icon="event"
                                    @click:append="dob_date_menu = true"
                                    :hint="'Format: ' + DATE_FORMAT"
                                    :disabled="fields_disabled"
                                    autocomplete="new-password"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  color="primary"
                                  v-model="enrolment.date_of_birth"
                                  first-day-of-week="1"
                                  :disabled="fields_disabled"
                                  :locale="$locale_bcp47(locale)"
                                  :max="moment().subtract(1, 'days').format(MYSQL_DATE_FORMAT)"
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn text color="primary" class="darken-2" @click="dob_date_menu = false">{{ $t("global.ok") }}</v-btn>
                                </v-date-picker>
                              </v-dialog>
                            </v-flex>
                            <v-flex xs12>
                              <v-textarea
                                name="enrolment.comments"
                                v-model="enrolment.comments"
                                rows="2"
                                auto-grow
                                :label="$t('fe.enrolment.comment')"
                                :error-messages="errors.collect('enrolment.comments')"
                              ></v-textarea>
                            </v-flex>
                          </v-layout>

                          <v-divider class="my-4"></v-divider>

                          <v-subheader class="pl-0">{{ $t("courses.address_title") }}</v-subheader>

                          <v-layout wrap>
                            <v-flex lg4 md4 sm6 xs12>
                              <v-text-field
                                name="p_address_street"
                                v-model="enrolment.street"
                                v-validate="'max:50'"
                                :label="$t('fe.enrolment.p_address_street')"
                                :error-messages="errors.collect('p_address_street')"
                                :disabled="fields_disabled"
                                autocomplete="new-password"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg2 md2 sm4 xs12>
                              <v-text-field
                                name="p_address_zip"
                                v-model="enrolment.zip"
                                v-validate="'max:6'"
                                :label="$t('fe.enrolment.p_address_zip')"
                                :error-messages="errors.collect('p_address_zip')"
                                :disabled="fields_disabled"
                                @blur="invoiceZipCodeChange"
                                autocomplete="new-password"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 md4 sm8 xs12>
                              <v-text-field
                                name="p_address_city"
                                v-model="enrolment.city"
                                v-validate="'max:50'"
                                :label="$t('fe.enrolment.p_address_city')"
                                :error-messages="errors.collect('p_address_city')"
                                :disabled="fields_disabled"
                                autocomplete="new-password"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg2 md2 sm6 xs12>
                              <v-autocomplete
                                name="p_address_country"
                                v-model="enrolment.country"
                                :items="this.$dd_countries()"
                                item-text="text"
                                item-value="key"
                                :label="$t('fe.enrolment.p_address_country')"
                                autocomplete="new-password"
                                :error-messages="errors.collect('p_address_country')"
                                :disabled="fields_disabled"
                                clearable
                              ></v-autocomplete>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex lg4 md4 sm12 xs12 v-if="!enrolmentDone">
                <v-card>
                  <v-card-text class="pa-4">
                    <p class="font-weight-black sidebar-price-title">{{ $t("fe.enrolment.include") }}</p>
                    <div v-for="(mt, index) in moduletemplates_included" :key="mt.id">
                      <p class="font-weight-black mb-0">{{ mt.name }}</p>

                      <div v-if="mt.moduleoptions.length > 0">
                        <v-radio-group
                          dense
                          v-model="selectedIncAdditionals[mt.id].selected_option"
                          @change="moduleoptionChangeInc"
                          class="mt-0 radio-full-width"
                          v-validate="'required'"
                          :name="'mo.' + mt.id"
                        >
                          <v-simple-table dense>
                            <tr v-if="!mt.mandatory">
                              <td scope="row">
                                <v-radio dense :label="$t('global.none_select')" value="none" :disabled="fields_disabled"></v-radio>
                              </td>
                              <td scope="row" class="text-end" width="20%"></td>
                            </tr>
                            <template v-for="mo in mt.moduleoptions">
                              <tr :key="'mo-' + mo.id">
                                <td scope="row">
                                  <v-radio
                                    dense
                                    :label="mo.name + (mo.hours > 0 ? ' (' + mo.hours + ' ' + $t('moduleoptions.hours') + ')' : '')"
                                    :value="mo.id"
                                    :disabled="fields_disabled"
                                  ></v-radio>
                                  <span class="pl-3 mb-1 d-block">{{ mo.comment }}</span>
                                </td>
                                <td scope="row" class="text-end va-text-top price" width="20%">
                                  <span v-if="mo.price">{{ mo.price + " " + CURRENCY }}</span>
                                </td>
                              </tr>

                              <template
                                v-if="
                                  moduleoptioncoursetypesinc[mo.id].length > 0 && selectedIncAdditionals[mt.id].selected_option == mo.id
                                "
                              >
                                <tr :key="'mo-mtname-' + mo.id">
                                  <td class="pl-3">
                                    <p class="mb-0">
                                      <span class="font-italic">{{ $t("fe.enrolment.select_course_types") }}</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr v-for="moct in moduleoptioncoursetypesinc[mo.id]" :key="moct.id">
                                  <td scope="row" class="pl-3">
                                    <v-checkbox
                                      :name="'moct.' + mt.id"
                                      dense
                                      :label="moct.name"
                                      v-model="selectedIncAdditionals[mt.id].selected_coursetypes"
                                      :value="moct.id"
                                      class="chk-moduleoption mt-0"
                                      @change="moduleoptionChangeInc"
                                      v-validate="'required'"
                                      :disabled="fields_disabled"
                                    >
                                    </v-checkbox>
                                    <span class="pl-3 mb-3 d-block">{{ moct.comment }}</span>
                                  </td>
                                  <td scope="row" class="text-end va-text-top price pl-3" width="20%">
                                    <span v-if="moct.price">{{ moct.price + " " + CURRENCY }}</span>
                                  </td>
                                </tr>
                              </template>
                            </template>
                            <tr v-if="errors.first('moct.' + mt.id)">
                              <td>
                                <div class="v-messages theme--light error--text mb-2">
                                  <div class="v-messages__wrapper">
                                    <div class="v-messages__message">
                                      {{ errors.first("moct." + mt.id) }}
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </v-simple-table>
                        </v-radio-group>
                        <div class="v-messages theme--light error--text mb-2">
                          <div class="v-messages__wrapper">
                            <div class="v-messages__message">{{ errors.first("mo." + mt.id) }}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <v-divider class="mb-3"></v-divider>

                    <p class="font-weight-black sidebar-price-title">{{ $t("fe.enrolment.additionals") }}</p>

                    <div v-for="(mt, index) in moduletemplates_not_included" :key="mt.id">
                      <p class="font-weight-black mb-0">{{ mt.name }}</p>

                      <v-radio-group
                        dense
                        v-model="selectedAdditionals[mt.id].selected_option"
                        @change="moduleoptionChange"
                        class="mt-0 radio-full-width"
                        v-validate="'required'"
                        :name="'mo.' + mt.id"
                      >
                        <v-simple-table dense>
                          <tr v-if="!mt.mandatory">
                            <td scope="row">
                              <v-radio dense :label="$t('global.none_select')" value="none" :disabled="fields_disabled"></v-radio>
                            </td>
                            <td scope="row" class="text-end" width="20%"></td>
                          </tr>

                          <template v-for="mo in mt.moduleoptions">
                            <tr :key="'mo-' + mo.id">
                              <td scope="row">
                                <v-radio
                                  dense
                                  :label="mo.name + (mo.hours > 0 ? ' (' + mo.hours + ' ' + $t('moduleoptions.hours') + ')' : '')"
                                  :value="mo.id"
                                  :disabled="fields_disabled"
                                ></v-radio>
                                <span class="pl-3 mb-3 d-block">{{ mo.comment }}</span>
                              </td>
                              <td scope="row" class="text-end va-text-top price" width="20%">
                                <span v-if="mo.price">{{ mo.price + " " + CURRENCY }}</span>
                              </td>
                            </tr>
                            <template
                              v-if="moduleoptioncoursetypes[mo.id].length > 0 && selectedAdditionals[mt.id].selected_option == mo.id"
                            >
                              <tr :key="'mo-mtname-' + mo.id">
                                <td class="pl-3">
                                  <p class="mb-0">
                                    <span class="font-italic">{{ $t("fe.enrolment.select_course_types") }}</span>
                                  </p>
                                </td>
                              </tr>
                              <tr v-for="moct in moduleoptioncoursetypes[mo.id]" :key="moct.id">
                                <td scope="row" class="pl-3">
                                  <v-checkbox
                                    :name="'moct.' + mt.id"
                                    dense
                                    :label="moct.name"
                                    v-model="selectedAdditionals[mt.id].selected_coursetypes"
                                    :value="moct.id"
                                    class="chk-moduleoption mt-0"
                                    @change="moduleoptionChange"
                                    v-validate="'required'"
                                    :disabled="fields_disabled"
                                  >
                                  </v-checkbox>
                                  <span class="pl-3 mb-3 d-block">{{ moct.comment }}</span>
                                </td>
                                <td scope="row" class="text-end va-text-top price" width="20%">
                                  <span v-if="moct.price">{{ moct.price + " " + CURRENCY }}</span>
                                </td>
                              </tr>
                            </template>
                          </template>
                          <tr v-if="errors.first('moct.' + mt.id)">
                            <td>
                              <div class="v-messages theme--light error--text mb-2">
                                <div class="v-messages__wrapper">
                                  <div class="v-messages__message">
                                    {{ errors.first("moct." + mt.id) }}
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </v-simple-table>
                      </v-radio-group>
                      <div class="v-messages theme--light error--text mb-2">
                        <div class="v-messages__wrapper">
                          <div class="v-messages__message">{{ errors.first("mo." + mt.id) }}</div>
                        </div>
                      </div>
                    </div>

                    <v-divider class="mb-3"></v-divider>

                    <v-simple-table dense class="mt-3">
                      <tr>
                        <td scope="row">
                          <p class="font-weight-black price">{{ $t("fe.enrolment.price") }}</p>
                        </td>
                        <td scope="row" class="text-end price" width="20%">
                          <span>{{ price + " " + CURRENCY }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td scope="row">
                          <p class="font-weight-black price">{{ $t("fe.enrolment.price_additional") }}</p>
                        </td>
                        <td scope="row" class="text-end price" width="20%">
                          <span>{{ price_additional + " " + CURRENCY }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td scope="row">
                          <p class="font-weight-black price">{{ $t("fe.enrolment.price_total") }}</p>
                        </td>
                        <td scope="row" class="text-end price" width="20%">
                          <span>{{ price_total + " " + CURRENCY }}</span>
                        </td>
                      </tr>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>

        <v-flex xs12 v-if="!enrolmentDone">
          <v-divider class="my-2"></v-divider>
          <v-card class="bottom-card">
            <v-card-text class="pa-1">
              <v-container grid-list-md class="pa-0">
                <v-layout wrap>
                  <v-flex xs12>
                    <v-layout wrap>
                      <vue-recaptcha ref="recaptcha" class="captcha d-none" mx-auto :sitekey="RECAPTCHA_KEY"> </vue-recaptcha>

                      <v-flex xs12 md8 class="text-center">
                        <v-checkbox name="coursetype" dense v-model="accept_privacy" v-validate="'required'" class="d-inline-flex">
                        </v-checkbox>
                        <p class="d-inline-flex va-top privacy-line">
                          {{ $t("fe.enrolment.privacy_consent_to") }}
                          <a @click="show_policy = !show_policy" class="pl-1 privacy-link">{{ $t("fe.enrolment.privacy_notice") }}</a>
                        </p>

                        <br />

                        <v-btn
                          class="button_text--text cstm-v-btn darken-2"
                          color="primary"
                          large
                          @click="validateEnrol"
                          :disabled="!validForm || !accept_privacy"
                        >
                          {{ pay_with_klarna ? $t("fe.enrolment.pay_and_enrol") : $t("fe.enrolment.submit") }}
                        </v-btn>

                        <action-button type="back" @click="back" large color="error" v-if="!modal" />
                        <action-button type="cancel" @click="$emit('return_modal_form', 'cancel')" large color="error" v-if="modal" />
                      </v-flex>
                      <v-flex xs12 md4 class="text-center"></v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 v-if="enrolmentDone">
          <v-card class="mx-auto mt-10" max-width="50%" color="success" dark>
            <v-card-title class="headline">{{
              course && course.send_email_notification
                ? $t("fe.enrolment.enrolment_success")
                : $t("fe.enrolment.enrolment_success_noemailsms")
            }}</v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <privacyPolicy :show="show_policy" :locale="locale" @callback_privacy_cancel="show_policy = false" />

    <klarna-payment
      :show="klarna_show"
      :type="klarna_type"
      :order_data="klarna_order_data"
      :enrolment_ids="klarna_enrolment_ids"
      @klarna_success="klarnaSuccess"
      @klarna_failed="klarnaFailed"
      @klarna_cancel="klarnaClear"
    />
  </v-form>
</template>

<script>
import { VueRecaptcha } from "@/mixins/vue-recaptcha"
import privacyPolicy from "../partials/Privacy"
import PhoneNumber from "awesome-phonenumber"
import VueTelInputVuetify from "@/mixins/vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue"

export default {
  name: "EnrolmentPersonal",

  props: ["locale", "cid", "autofill_data", "modal"],

  components: {
    privacyPolicy,
    VueRecaptcha,
    VueTelInputVuetify,
    "klarna-payment": () => import("@/mixins/components/klarnaPayment")
  },

  data() {
    return {
      page_title: "",

      coursetemplate: {},
      course: {},
      enrolment: {},
      enrolmentDone: false,
      participant: {},

      readMoreActivated: false,

      moduletemplates: [],
      moduletemplates_included: [],
      moduletemplates_not_included: [],

      moduleoptioncoursetypes: {},
      selectedAdditionals: {},

      moduleoptioncoursetypesinc: {},
      selectedIncAdditionals: {},

      price: 0,
      price_additional: 0,
      price_total: 0,

      available_enrolment: 0,
      fields_disabled: false,
      accept_privacy: false,
      show_policy: false,

      recaptchaData: null,

      integrations: [],
      integration_klarna: null,
      pay_with_klarna: false,

      klarna_show: false,
      klarna_type: null,
      klarna_order_id: null,
      klarna_token: null,
      klarna_payment_methods: [],
      klarna_order_data: {},
      klarna_enrolment_ids: [],
      klarna_order_lines: [],

      active_tab: 0,
      dob_date_menu: false,
      dictionary: {
        attributes: {
          p_course_id: this.$t("fe.enrolment.p_course_id"),
          p_first_name: this.$t("fe.enrolment.p_first_name"),
          p_last_name: this.$t("fe.enrolment.p_last_name"),
          p_email: this.$t("fe.enrolment.p_email"),
          p_mobile: this.$t("fe.enrolment.p_mobile"),
          p_date_of_birth: this.$t("fe.enrolment.p_date_of_birth"),
          p_address_street: this.$t("fe.enrolment.p_address_street"),
          p_address_city: this.$t("fe.enrolment.p_address_city"),
          p_address_state: this.$t("fe.enrolment.p_address_state"),
          p_address_zip: this.$t("fe.enrolment.p_address_zip"),
          p_address_country: this.$t("fe.enrolment.p_address_country"),
          coursetype: this.$t("moduleoptioncoursetypes.coursetype_id")
        }
      }
    }
  },

  computed: {
    computedDateofBirth: {
      get() {
        return this.$dateFormatGetter(this.enrolment.date_of_birth)
      },
      set(val) {
        this.$set(this.enrolment, "date_of_birth", this.$dateFormatSetter(val))
      }
    },
    validForm() {
      let bool = true

      if (!this.enrolment.first_name) bool = false
      if (!this.enrolment.last_name) bool = false
      if (!this.enrolment.email) bool = false
      if (!this.enrolment.mobile) bool = false
      if (!this.enrolment.date_of_birth) bool = false

      return bool
    }
  },

  created() {
    let vm = this

    this.$updateSetting("fe_locale", this.locale)
    this.$i18n.locale = this.locale

    axios
      .get(this.API_URL + "open/organisation/my")
      .then((res) => {
        let data = res.data.data

        this.$store.dispatch("frontend/setOrganisation", data)

        this.$setTenantInAxiosHeader(data.tenant_id)
        this.enrolment.country = this.$getDefaultDropdown(this.$dd_countries())
        this.enrolment.mobile_code = "47"

        this.integrations = data.integrations
        if (this.integrations) {
          this.integration_klarna = this.integrations.find((i) => i.slug == this.INTEGRATION_SLUG_KLARNA)
        }

        if (this.cid) {
          axios.get(this.API_URL + "open/course/uuid/" + this.cid).then((res) => {
            this.course = res.data.data
            let available_enrolment = this.course.num_places - this.course.num_enrolled

            this.pay_with_klarna = Boolean(
              this.integration_klarna &&
                this.course.klarna_checkout &&
                (this.course.klarna_checkout_type == 1 || this.course.klarna_checkout_type == 3)
            )

            // Check if course is_published is checked
            // Check if enrolment_due_date is still valid
            // Check if available sits is still available
            if (
              (this.course && !this.course.allow_overbook && Boolean(available_enrolment <= 0)) ||
              (this.course && this.moment(this.course.enrolment_due_date).diff(this.moment(), "days") < 0)
            ) {
              if(this.autofill_data) {
                this.initCourse()
              } else {
                this.$router.push("/f/" + this.locale + "/enrolment/personal/interest")
                this.fields_disabled = true
              }
            } else {
              this.initCourse()
            }
          })
        }
      })
      .catch((err) => console.log(err))
  },

  mounted() {
    this.$validator.localize(this.locale, this.dictionary)
  },

  methods: {
    phoneNoSpace() {
      if (this.enrolment.mobile) {
        this.enrolment.mobile = this.enrolment.mobile.replace(/\s/g, "")
        let field = this.errors.items.find((i) => i.field == "p_mobile" && i.rule == "no_space")
        if (field) this.$validator.errors.removeById(field.id)
      }
    },
    initCourse(id) {
      let vm = this

      if (this.course) {
        let course = this.course
        let title = []

        if (course.start_date) title.push(this.moment.utc(course.start_date).format(this.DATE_FORMAT))
        if (course.address.city) title.push(course.address.city)
        if (course.name) title.push(course.name)

        if (title.length > 0) {
          this.page_title = title.join(", ")
        }

        this.enrolment.course_id = course.id
        this.available_enrolment = course.num_places - course.num_enrolled

        if(this.autofill_data && this.autofill_data.participants.length > 0) {
          this.participant = this.autofill_data.participants[0]

          this.$set(this.enrolment, "first_name", this.participant.first_name)
          this.$set(this.enrolment, "last_name", this.participant.last_name)
          this.$set(this.enrolment, "email", this.participant.email)
          this.$set(this.enrolment, "mobile", this.participant.mobile)
          this.$set(this.enrolment, "date_of_birth", this.participant.date_of_birth)
        }

        this.moduletemplates = this.course.moduletemplates

        // Filter "Included" module templates
        this.moduletemplates_included = this.moduletemplates.filter((i) => i.is_included == 1 && !i.hide_in_enrolment)

        this.moduletemplates_included.forEach(function (mt) {
          vm.$set(vm.selectedIncAdditionals, mt.id, {})
          vm.$set(vm.selectedIncAdditionals[mt.id], "selected_coursetypes", [])

          if (mt.moduleoptions.length == 1) {
            vm.$set(vm.selectedIncAdditionals[mt.id], "selected_option", mt.mandatory ? mt.moduleoptions[0].id : "none")
          } else {
            vm.$set(vm.selectedIncAdditionals[mt.id], "selected_option", mt.mandatory ? "" : "none")
          }

          // Show only module option where "Enrol Select" is checked
          mt.moduleoptions = mt.moduleoptions.filter((i) => i.enrol_select == 1)

          mt.moduleoptions.forEach(function (mo) {
            vm.moduleoptioncoursetypesinc[mo.id] = []
            vm.moduleoptioncoursetypesinc[mo.id] = mo.coursetypes
          })

          // Add dynamic name for checking of moduleoption coursetype
          vm.dictionary.attributes["mo." + mt.id] = vm.$t("moduleoptions.moduleoption_id")
          vm.dictionary.attributes["moct." + mt.id] = vm.$t("moduleoptioncoursetypes.coursetype_id")
        })

        // Filter "Not Included" module templates
        this.moduletemplates_not_included = this.moduletemplates.filter((i) => i.is_included != 1 && !i.hide_in_enrolment)

        this.moduletemplates_not_included.forEach(function (mt) {
          vm.$set(vm.selectedAdditionals, mt.id, {})
          vm.$set(vm.selectedAdditionals[mt.id], "selected_coursetypes", [])

          if (mt.moduleoptions.length == 1) {
            vm.$set(vm.selectedAdditionals[mt.id], "selected_option", mt.mandatory ? mt.moduleoptions[0].id : "none")
          } else {
            vm.$set(vm.selectedAdditionals[mt.id], "selected_option", mt.mandatory ? "" : "none")
          }

          // Show only module option where "Enrol Select" is checked
          mt.moduleoptions = mt.moduleoptions.filter((i) => i.enrol_select == 1)

          mt.moduleoptions.forEach(function (mo) {
            vm.moduleoptioncoursetypes[mo.id] = []
            vm.moduleoptioncoursetypes[mo.id] = mo.coursetypes
          })

          // Add dynamic name for checking of moduleoption coursetype
          vm.dictionary.attributes["mo." + mt.id] = vm.$t("moduleoptions.moduleoption_id")
          vm.dictionary.attributes["moct." + mt.id] = vm.$t("moduleoptioncoursetypes.coursetype_id")
        })

        // Reinitialize validator dictionary
        vm.$validator.localize(vm.locale, vm.dictionary)
        this.recompute()
      }
    },
    recompute() {
      let vm = this

      vm.price = Boolean(_.has(vm.course, "id")) ? vm.course.price : 0
      vm.price_additional = 0
      vm.price_total = 0

      vm.klarna_order_lines = []

      vm.klarna_order_lines.push({
        name: this.course.name,
        quantity: 1,
        unit_price: vm.price * 100,
        tax_rate: 0,
        total_amount: vm.price * 100,
        total_tax_amount: 0
      })

      _.forEach(vm.selectedIncAdditionals, function (obj, key) {
        let mt = vm.moduletemplates_included.find((i) => i.id == key)
        let selected_option = obj.selected_option

        if (mt && selected_option != "" && selected_option != "none" && vm.moduleoptioncoursetypesinc[selected_option] !== undefined) {
          // Add the price of the selected module option
          let mo = mt.moduleoptions.find((i) => i.id == selected_option)
          if (mo) {
            vm.price_additional += mo.price
            vm.klarna_order_lines.push({
              name: mo.name,
              quantity: 1,
              unit_price: mo.price * 100,
              tax_rate: 0,
              total_amount: mo.price * 100,
              total_tax_amount: 0
            })
          }

          // Add the price of the selected course types
          _.forEach(obj.selected_coursetypes, function (ct) {
            let moct = vm.moduleoptioncoursetypesinc[selected_option].find((i) => i.id == ct)

            if (moct) {
              vm.price_additional += moct.price
              vm.klarna_order_lines.push({
                name: moct.name,
                quantity: 1,
                unit_price: moct.price * 100,
                tax_rate: 0,
                total_amount: moct.price * 100,
                total_tax_amount: 0
              })
            }
          })
        }
      })

      _.forEach(vm.selectedAdditionals, function (obj, key) {
        let mt = vm.moduletemplates_not_included.find((i) => i.id == key)
        let selected_option = obj.selected_option

        if (mt && selected_option != "" && selected_option != "none" && vm.moduleoptioncoursetypes[selected_option] !== undefined) {
          // Add the price of the selected module option
          let mo = mt.moduleoptions.find((i) => i.id == selected_option)
          if (mo) {
            vm.price_additional += mo.price
            vm.klarna_order_lines.push({
              name: mo.name,
              quantity: 1,
              unit_price: mo.price * 100,
              tax_rate: 0,
              total_amount: mo.price * 100,
              total_tax_amount: 0
            })
          }

          // Add the price of the selected course types
          _.forEach(obj.selected_coursetypes, function (ct) {
            let moct = vm.moduleoptioncoursetypes[selected_option].find((i) => i.id == ct)

            if (moct) {
              vm.price_additional += moct.price
              vm.klarna_order_lines.push({
                name: moct.name,
                quantity: 1,
                unit_price: moct.price * 100,
                tax_rate: 0,
                total_amount: moct.price * 100,
                total_tax_amount: 0
              })
            }
          })
        }
      })

      vm.price_total = vm.price + vm.price_additional
    },

    moduleoptionChange() {
      let vm = this

      _.forEach(vm.selectedAdditionals, function (obj, key) {
        let selected_option = obj.selected_option
        let selected_coursetypes = obj.selected_coursetypes

        if (selected_option != "" && selected_option != "none" && vm.moduleoptioncoursetypes[selected_option] !== undefined) {
          let moct_ids = vm.moduleoptioncoursetypes[selected_option].map((a) => a.id)
          obj.selected_coursetypes = _.intersection(moct_ids, selected_coursetypes)
        } else {
          obj.selected_coursetypes = []
        }
      })

      vm.recompute()
    },

    moduleoptionChangeInc() {
      let vm = this

      _.forEach(vm.selectedIncAdditionals, function (obj, key) {
        let selected_option = obj.selected_option
        let selected_coursetypes = obj.selected_coursetypes

        if (selected_option != "" && selected_option != "none" && vm.moduleoptioncoursetypesinc[selected_option] !== undefined) {
          let moct_ids = vm.moduleoptioncoursetypesinc[selected_option].map((a) => a.id)
          obj.selected_coursetypes = _.intersection(moct_ids, selected_coursetypes)
        } else {
          obj.selected_coursetypes = []
        }
      })

      vm.recompute()
    },

    validateEnrol() {
      this.$validator.validate()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.course && !this.course.allow_overbook && Boolean(this.available_enrolment <= 0)) {
            this.$awn.confirm(
              this.$t("fe.enrolment.course_full_register"),
              () => {
                this.enrol()
              },
              () => {
                return
              }
            )
          } else {
            this.enrol()
          }
        } else {
          this.$awn.alert(this.$t("global.form_not_valid"))
        }
      })
    },

    enrol() {
      let vm = this

      let vdata = [
        {
          course_id: this.enrolment.course_id,
          first_name: this.enrolment.first_name,
          last_name: this.enrolment.last_name,
          email: this.enrolment.email,
          date_of_birth: this.enrolment.date_of_birth
        }
      ]

      // VALIDATE
      axios
        .post(this.API_URL + "open/enrolment/validate", {
          data: JSON.stringify(vdata)
        })
        .then((res) => {
          let status = res.data.status
          let duplicates = res.data.duplicates

          if (res.data.status == "not-valid") {
            if (duplicates.length > 0) {
              let names = []

              duplicates.forEach((item, index) => {
                names[index] = item.first_name + " " + item.last_name
              })

              vm.$awn.alert(
                vm.$t("fe.enrolment.enrolment_duplicate", {
                  names: names.join(", ")
                })
              )
            }
          } else {
            axios
              .post(this.API_URL + "open/enrolment", {
                site: process.env.VUE_APP_DOMAIN,
                subdomain: vm.SUBDOMAIN,
                course_id: this.enrolment.course_id,
                participant_id: this.participant.id || null,
                first_name: this.enrolment.first_name,
                last_name: this.enrolment.last_name,
                email: this.enrolment.email,
                mobile: this.$formatPhoneNumber(this.enrolment.mobile, this.enrolment.mobile_code),
                date_of_birth: this.enrolment.date_of_birth,
                street: this.enrolment.street,
                city: this.enrolment.city,
                state: "",
                zip: this.enrolment.zip,
                country: this.enrolment.country,
                comments: this.enrolment.comments,
                created_by: null,
                type: "personal",
                mode: "enrolment",
                price: this.price,
                price_additional: this.price_additional,
                price_total: this.price_total,
                additionals: JSON.stringify(this.selectedAdditionals),
                additionals_inc: JSON.stringify(this.selectedIncAdditionals),
                course_full: Boolean(this.available_enrolment <= 0) && !this.course.allow_overbook,
                pay_with_klarna: this.pay_with_klarna
              })
              .then((res) => {
                if (typeof res.data.errors !== "undefined") {
                } else {
                  let ids = res.data.ids || null
                  let data_ids = res.data.data_ids || null

                  if (ids) {
                    if (this.pay_with_klarna) {
                      this.klarnaCheckout(ids)
                    } else {
                      vm.$refs.form.reset()
                      vm.errors.items = []
                      vm.accept_privacy = false

                      vm.moduletemplates_included.forEach(function (mt) {
                        vm.$set(vm.selectedIncAdditionals[mt.id], "selected_option", mt.mandatory ? "" : "none")
                      })

                      vm.moduletemplates_not_included.forEach(function (mt) {
                        vm.$set(vm.selectedAdditionals[mt.id], "selected_option", mt.mandatory ? "" : "none")
                      })

                      if(this.modal && this.autofill_data) {
                        vm.$emit('return_modal_form', data_ids)
                      } else {
                        vm.enrolmentDone = true
                        window.scrollTo(0, 0)
                      }
                    }
                  } else {
                    vm.$swal({
                      text: vm.$t("fe.enrolment.enrolment_error"),
                      icon: "error",
                      closeOnClickOutside: false,
                      closeOnEsc: false
                    })
                  }
                }
              })
              .catch((err) => console.log(err))
          }
        })
        .catch((err) => console.log(err))
    },

    invoiceZipCodeChange() {
      this.$getCity(this.enrolment.zip, this.enrolment.country)
        .then((res) => {
          if (res.status == 200) {
            this.$set(this.enrolment, "city", res.data.postalCode.city)
          }
        })
        .catch((error) => {
          this.$set(this.enrolment, "city", null)
        })
    },

    back() {
      if (this.course) {
        this.$router.push("/f/" + this.locale + "/enrolment/template/" + this.course.coursetemplate.uuid + "/course/" + this.course.uuid)
      }
    },

    klarnaCheckout(ids) {
      // CHECKOUT API
      let order_data = {
        purchase_country: "NO",
        purchase_currency: "NOK",
        locale: "en-US",
        order_amount: this.price_total * 100,
        order_tax_amount: 0,
        order_lines: this.klarna_order_lines,
        billing_address: {
          given_name: this.enrolment.first_name,
          family_name: this.enrolment.last_name,
          email: this.enrolment.email,
          phone: this.enrolment.mobile,
          street_address: this.enrolment.street,
          city: this.enrolment.city,
          postal_code: this.enrolment.zip,
          country: this.countryAlpha2(this.enrolment.country)
        },
        customer: {
          type: "person",
          date_of_birth: this.enrolment.date_of_birth
        },
        merchant_urls: {
          terms: "https://www.example.com/terms.html",
          checkout: "https://www.example.com/checkout.html",
          confirmation: `https://${window.location.hostname}/f/no/klarna/checkout/order-confirmation/{checkout.order.id}`,
          push: "https://www.example.com/api/push"
        }
      }

      this.klarna_type = "checkout"
      this.klarna_order_data = order_data
      this.klarna_enrolment_ids = ids
      this.klarna_show = true
    },
    klarnaSuccess(data) {
      this.$awn.success("Order ID: " + data.order_id)
      this.klarnaClear()
    },
    klarnaFailed(data) {
      let error = data.error || this.$t("auth.invalidrequest_t")
      this.$awn.alert(error)
      this.paymentClear()
    },
    klarnaClear() {
      this.klarna_order_data = {}
      this.klarna_show = false
    }
  }
}
</script>

<style>
.privacy-line {
  margin-top: 10px;
}
.privacy-link {
  font-size: 14px;
}
.chk-moduleoption {
  height: 30px;
  padding-top: 3px;
  margin-top: 0;
}
.text-gray {
  color: rgba(0, 0, 0, 0.54) !important;
}
.v-messages {
  min-height: 0 !important;
}
.bottom-card {
  box-shadow: none !important;
}
p.price,
.price span {
  font-size: 14px !important;
}
</style>
